import * as HoverCardPrimitive from '@radix-ui/react-hover-card';

export const HoverCard = HoverCardPrimitive.Root;
